<template>
  <div v-if="currentMoObject && currentPlanObject">
    <div>
      <p class="lead text-muted m-0">{{ 'Subscribe to' | translate }} {{ page.name }}</p>
    </div>
    <div class="" v-if="trial && !isFree">
      <div class="checkout--trial">
        <div>
          <span class="h1">
            {{ trial.days }}
            {{ 'days' | translate }}
          </span>
          <span class="h1" v-if="['Tpay', 'PayU'].includes(paymentProvider)">
            {{ 'for' | translate }}
            {{ trial.amount | price(page.currency) }}
          </span>
          <span class="h1" v-else-if="['Stripe'].includes(paymentProvider)">
            {{ 'free' | translate }}
          </span>
        </div>
        <div>
          <p class="lead text-muted">
            {{ 'Then' | translate }}
            {{ currentPlanObject.price | price(page.currency) }}
            {{ currentPlanObject.title | translate }}
          </p>
        </div>
      </div>
    </div>
    <div v-else class="d-flex align-items-baseline">
      <div>
        <span class="h1">
          {{ currentPlanObject.price | price(page.currency) }}
        </span>
      </div>
      <div class="ms-2">
        <span class="text-muted">
          {{ currentPlanObject.title | translate }}
        </span>
      </div>
    </div>
    <div class="mt-4">
      <div v-if="plansVisible.length > 1 && !currentMoObject.is_hidden" class="mb-4">
        <select v-model="selectedMo" class="form-select text-uppercase px-3 py-3 fw-bold" aria-label="Selected plan">
          <option v-for="mo in plansVisible" :key="mo.header">{{ mo.header | translate }}</option>
        </select>
      </div>
      <div class="checkout--plan" v-for="(plan, index) in currentMoObject.plans" :key="plan.name">
        <div
          class="card mb-3 membership-plan"
          style="cursor: pointer"
          :class="{
            // shadow: currentPlan === plan.name,
            'border-2 border-success': currentPlan === plan.name,
          }"
          @click="chosePlan(plan.name)"
        >
          <div
            class="card-body bg-opacity-10"
            :class="{
              'text-muted': currentPlan !== plan.name,
              'bg-success': currentPlan === plan.name,
            }"
          >
            <div class="d-flex">
              <div>
                <div>
                  <span
                    class="text-capitalize"
                    :class="{
                      'fw-bold': currentPlan === plan.name,
                    }"
                  >
                    {{ plan.title | translate }}
                  </span>
                </div>
                <div v-if="plan.name === 'lifetime'">
                  <small>
                    <span class="text-success">
                      {{ 'Lifetime access' | translate }}
                    </span>
                  </small>
                </div>
                <div v-if="currentPlan !== plan.name">
                  <small v-if="savings[index] < 0">
                    <span class="text-secondary">{{ 'You save' | translate }}:</span>
                    <span class="p-1 text-success fw-semibold">
                      {{ savings[index] | price(page.currency) }}
                    </span>
                  </small>
                </div>
              </div>
              <div class="ms-auto">
                <span class="fw-bold">
                  {{ plan.oldPrice || plan.price | price(page.currency) }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="mt-3">
      <div class="mb-2" v-if="priceDiff && showPromoCodeField">
        {{ 'Discount' | translate }}
      </div>
      <div class="d-flex align-items-center">
        <PromoCode v-show="showPromoCodeField" class="w-100"></PromoCode>
        <div v-if="priceDiff && !showPromoCodeField">
          {{ 'Discount' | translate }}
        </div>
        <div class="ms-auto text-muted" v-if="priceDiff">
          <span>{{ priceDiff | price(page.currency) }}</span>
        </div>
      </div>
      <hr v-if="priceDiff || showPromoCodeField" />
    </div>
    <div v-if="trial" class="mb-3">
      <div class="d-flex align-items-center small mb-2">
        <div>
          {{ 'Total after trial' | translate }}
        </div>
        <div class="ms-auto">
          {{ currentPlanObject.price | price(page.currency) }}
        </div>
      </div>
      <div class="d-flex align-items-center">
        <div class="fw-bold">
          {{ 'Total due today' | translate }}
        </div>
        <div class="ms-auto h5 mb-0 fw-bold" v-if="['Tpay', 'PayU'].includes(paymentProvider)">
          {{ trial.amount | price(page.currency) }}
        </div>
        <div class="ms-auto h5 mb-0 fw-bold" v-if="['Stripe'].includes(paymentProvider)">
          {{ 0 | price(page.currency) }}
        </div>
      </div>
    </div>
    <div v-else class="mb-3">
      <div class="d-flex align-items-center">
        <div class="fw-bold">
          {{ 'Total due today' | translate }}
        </div>
        <div class="ms-auto h5 fw-bold mb-0">
          {{ currentPlanObject.price | price(page.currency) }}
        </div>
      </div>
      <div class="d-flex align-items-center mt-2" v-if="currentPlanObject.title !== 'lifetime'">
        <div class="text-muted small">
          {{ 'Renews at' | translate }}
        </div>
        <div class="ms-auto mb-0 small">
          <span class="">{{ currentPlanObject.price | price(page.currency) }}</span>
          <span class="small">/ {{ currentPlanObject.title | translate }}</span>
        </div>
      </div>
    </div>
    <div v-if="checkoutInfo"
      class="mt-5 mb-3 checkout--additional-info-placeholder markdown" 
      v-html="snark(checkoutInfo)"
    ></div>
    <div v-if="currentPlanObject.title !== 'lifetime'" class="text-muted small mb-5">
      <hr>
      <div class="d-flex justify-content-start align-items-center"><i class="far fa-calendar-times me-2"></i> <span>{{ 'You can cancel at any time' | translate }}</span></div>
      <div class="d-flex justify-content-start align-items-center"><i class="far fa-bell me-2"></i> <span>Plan odnawia się automatycznie do momentu anulowania</span></div>
    </div>
  </div>
</template>

<script>
import PromoCode from './../PromoCode'
import snarkdown from 'snarkdown';

export default {
  components: {
    PromoCode,
  },
  methods: {
    chosePlan(plan) {
      this.$store.commit('setCurrentPlan', plan)
    },
    snark(value) {
      return snarkdown(value)
    },
  },
  filters: {
    price(value, currency) {
      return (value / 100).toLocaleString(document.documentElement.lang, {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
      })
    },
  },
  mounted() {
    this.$store.dispatch('checkPlanParams')
  },
  computed: {
    savings() {
      let len = (plan) => {
        if (plan === 'three') {
          return 3
        } else if (plan === 'six') {
          return 6
        } else if (plan === 'twelve') {
          return 12
        }
        return 1
      }
      return [...this.currentMoObject.plans].map((plan) => {
        let l = len(plan.name)

        return Math.round((plan.price / l - this.currentPlanObject.monthlyPrice) * l)
      })
    },
    priceDiff() {
      let diff = this.currentPlanObject.price - this.currentPlanObject.oldPrice
      if (diff < 0) {
        return diff
      }
      return 0
    },
    paymentProvider() {
      return this.$store.state.page.payment_provider
    },
    showPromoCodeField() {
      let view = this.$store.state.view
      // if (this.checkoutType === 'membership' && this.paymentProvider === 'Stripe') {
      //   return false
      // }
      if (this.student.email) {
        return this.$store.state.page.display_promo_code_field
      }
      if (view === 'register') {
        return this.$store.state.page.display_promo_code_field
      }
      return false
    },
    checkoutType() {
      return this.$store.state.checkoutType
    },
    student() {
      return this.$store.state.user
    },
    checkoutInfo() {
      if (this.currentMoObject.display_checkout_info) {
        return this.currentMoObject.checkout_info
      }
      return ''
    },
    trial() {
      if (this.currentMoObject.trial) {
        return {
          days: this.currentMoObject.trial_days,
          amount: this.currentMoObject.trial_amount,
        }
      }
      return false
    },
    page() {
      return this.$store.state.page
    },
    currentPlan() {
      return this.$store.state.currentPlan
    },
    currentMoObject() {
      return this.$store.getters.currentMo
    },
    currentPlanObject() {
      return this.$store.getters.currentPlan
    },
    selectedMo: {
      get() {
        return this.$store.getters.currentMo.header
      },
      set(value) {
        this.$store.commit('setCurrentMo', value)
      },
    },
    promoCode() {
      return this.$store.state.promoCode
    },
    plans() {
      return this.$store.getters.plans
    },
    plansVisible() {
      return this.$store.getters.plans.filter((plan) => !plan.is_hidden)
    },
    isFree() {
      return _.get(this.currentPlanObject, 'price') === 0
    },
  },
}
</script>

<style lang="scss">
.membership-plan {
  transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
}
</style>
